var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("您已退出工单系统，可关闭本页面。")])}
var staticRenderFns = []

export { render, staticRenderFns }